/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var _extends = _interopDefault(require('babel-runtime/helpers/extends'));
var minilo = require('../util/minilo');
var BingmapsSource = _interopDefault(require('../bingmaps-source'));

var Source = _extends({}, BingmapsSource.Source, {
  name: 'vl-source-bing-maps',
  created: function created() {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[VueLayers] Component vl-source-bing-maps was deprecated and will be removed later. ' + 'Please use the new vl-source-bingmaps component.');
    }
  }
});

var index = {
  Source: Source,
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options = minilo.pick(options, 'dataProjection');
    _Object$assign(Source, options);

    Vue.component(Source.name, Source);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/bing-maps-source/index.js
// module id = 1453
// module chunks = 1